const environments = {
    production: {
        baseUrl: "https://api.feelhq.co.uk/"
    },
    development: {
        baseUrl: "https://edufeel-api.dextrouslab.com/"
    },
    local: {
        baseUrl: "http://127.0.0.1:8000/"
    }
};

// Set current environment here
const currentEnv = "production"; // Change this to "production" or "development" as needed
const config = environments[currentEnv];

// Export all URLs
export const baseUrl = config.baseUrl;
export const imagesPath = `${baseUrl}images/`;
export const mediaUrl = `${imagesPath}nurseries/`;
export const ticketMediaUrl = `${imagesPath}ticket`;
export const ticketResponseMediaUrl = `${imagesPath}ticket_response`;
export const userMediaUrl = `${imagesPath}employee/`;

export const googleApiKey = "AIzaSyCD-1oVkve0-GfHCIm8pJrSlfW-DwCrUC4";

// Developer-only toggle for the Wellbeing Setup route.
// When false, the side-menu item is hidden and the route is not registered,
// so it cannot be opened from the menu or by typing the URL directly.
export const wellbeingSetupEnabled = false;